import { Component, inject } from '@angular/core';
import { Conversation } from '../../../../shared/models/conversation.model';
import { CommonModule } from '@angular/common';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { DashboardComponent } from '../../dashboard.component';

@Component({
  selector: 'app-display-chat',
  imports: [CommonModule],
  templateUrl: './display-chat.component.html',
  styleUrl: './display-chat.component.scss',
})
export class DisplayChatComponent {
  data = inject<Conversation>(MAT_BOTTOM_SHEET_DATA);

  private _bottomSheetRef =
    inject<MatBottomSheetRef<DashboardComponent>>(MatBottomSheetRef);

  openLink(event: MouseEvent): void {
    this._bottomSheetRef.dismiss();
    event.preventDefault();
  }
}
